import linkifyHtml from 'linkify-html';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import Expander from '../../../components/Expander';
import { theme } from '../../../components/GlobalStyles';
import { Box, Contain } from '../../../components/Grid';
import Image from '../../../components/Image';
import AboutDetails from '../../../components/PromoDetails/AboutDetails';
import StoreDetails from '../../../components/PromoDetails/StoreDetails';
import SeoHead from '../../../components/SeoHead';
import ShareButton from '../../../components/ShareButton';
import { getPromoDetails } from '../../../services/api';
import lineBreaker from '../../../utils/lineBreaker';
import useFormatDate from '../../../utils/useFormatDate';
import withErrorHandling from '../../../utils/withErrorHandling';
import Error404 from '../../404';

const StyledPromotion = styled.div`
  .promotion-page {
    margin-top: 2rem;
    text-align: left;

    .row {
      .columns {
        padding-left: 0;
        padding-right: 0;
      }
    }

    h4 {
      color: #aaa;
      text-align: left;
      margin-bottom: 2rem;
      a {
        color: #f58236;
        text-decoration: none;
      }
    }

    .promotion-wrapper {
      background: #fff;

      .header-container {
        width: 52%;
        float: left;
        margin: 0 auto 1.4285714286rem;

        .row {
          .columns {
            padding-left: 0;
            padding-right: 0;
          }
        }

        header {
          margin: 0 auto 1.4285714286rem;
          padding-bottom: 1.4285714286rem;

          p {
            font-size: 1rem;
          }

          .banner-container {
            position: relative;
            padding-bottom: 52.35%;
          }

          .logo-container {
            display: none;
            width: 8.688%;
            margin: auto;
          }

          .about-container {
            h3 {
              color: #aaa;
              font-size: 1rem;
            }
            font-size: 0.875rem;
          }

          .store-container {
            h3 {
              color: #aaa;
              font-size: 1rem;
            }

            ul {
              list-style: none;
              text-align: left;
              margin-left: 0;

              a {
                color: #f58236;
              }
            }

            ul.store-child-list {
              border-bottom: 0.0714285714rem solid #dadada;
              &:last-child {
                border-bottom: 0;
              }

              li {
                margin: 1.7142857143rem 0;

                &:first-child {
                  font-weight: bold;
                  font-size: 1.25rem;
                  margin-top: 1.1428571429rem;
                  line-height: 1;
                }

                &:last-child span {
                  vertical-align: middle;
                }
              }

              div.store-icon {
                background-image: url(/static/img/pages/discover/promotion/store.png);
                width: 1.5rem;
                height: 1.2857142857rem;
                background-size: contain;
                margin-right: 0.7142857143rem;
                display: inline-block;
                vertical-align: top;
                margin-top: 4px;
              }

              .list-store-address {
                display: flex;
              }

              div.store-address {
                display: inline-block;
                width: 90%;
              }

              div.call-icon {
                background-image: url(/static/img/pages/discover/promotion/call-promotion.png);
                width: 1.3571428571rem;
                height: 1.2857142857rem;
                background-size: cover;
                margin-right: 0.7142857143rem;
                display: inline-block;
                vertical-align: top;
                margin-top: 6px;
              }
            }
          }
        }

        .line-divider {
          width: auto;
          height: 0.2142857143rem;
          margin: 0 1rem;
          border-top: 1px solid #dadada;
        }
      }
    }

    .page {
      width: 48%;
      margin: auto;
      float: right;
      padding: 1rem 1.5rem 1rem 1.5rem;
      background: #fff;

      .first-block {
        margin-bottom: 1.5rem;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
        height: 24px;
      }

      .block-type {
        text-align: center;
        background: #fff;
        position: relative;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        display: inline-block;
        margin-top: 2px;
        padding: 0;

        h6 {
          font-size: 0.875rem;
          padding: 0.25rem;
          background: #000000;
          color: #fff;
          font-weight: normal;
          margin: 0;
          line-height: 1.3;
        }
      }

      .promotion-share {
        display: flex;
        align-items: center;
        img {
          display: block;
        }
      }

      ul.two-items {
        list-style: none;
        padding-left: 1rem;
        margin: 0;
        line-height: 1;

        li {
          display: inline-block;
          &:first-child {
            margin-right: 0.8rem;
          }
        }

        a {
          border-bottom: 0;
          color: #333333;
          width: 1.7142857143rem;
          height: 1.7142857143rem;
          display: inline-block;

          &:hover {
            text-decoration: none;
          }

          i {
            width: 1.7142857143rem;
            height: 1.7142857143rem;
            font-size: 1.7857142857rem;
          }
        }
      }

      .merchant-name {
        font-size: 2rem;
        color: #000;
        margin-bottom: 0.5rem;
      }

      .promotion-title {
        color: #000000;
        line-height: 1.07;
        text-transform: inherit;
        margin-bottom: 18px;
        margin-top: 0;
        font-weight: 400;
      }

      .row.validity-date {
        display: flex;
        align-items: center;
      }

      .info-table__label-icon {
        display: inline-block;
        margin-right: 0.7142857143rem;
        padding: 0;
        vertical-align: super;

        .calendar-icon {
          width: 1.2857142857rem;
          height: 1.2857142857rem;
          margin-right: 0.5rem;
        }
      }

      .info-table__label {
        text-transform: capitalize;
        font-size: 1.4285714286rem;
        line-height: 1.5;
        display: inline-block;
        margin: 0;
      }
      .info-table__text {
        font-size: 20px;
        font-weight: bold;
        color: #000;
        margin: 0.5rem 0.3571428571rem;
        display: block;
      }
      .info-table__text.validity-value {
        display: inline-block;
      }

      .line-divider {
        width: auto;
        height: 0.2142857143rem;
        border-top: 1px solid #dadada;
      }

      .description {
        h3 {
          color: #aaa;
          font-size: 1rem;
        }

        .columns,
        .subcontent {
          text-align: left;
          font-size: 0.875rem;
        }

        .subcontent {
          p {
            font-size: 1rem;
          }

          ul {
            margin-left: 1.2rem;
            li {
              font-size: 1rem;
            }
          }
        }

        .wysiwyg-content p:not(:first-child) {
          margin-top: 1rem;
        }
      }

      .image-title {
        p {
          font-size: 1rem;
          color: #000;
        }

        ul {
          margin-left: 1.2rem;
          li {
            font-size: 1rem;
          }
        }
      }

      .fine-prints {
        h3 {
          color: #aaa;
          font-size: 1rem;
        }
        font-size: 0.875rem;
        .details a {
          word-wrap: break-word;
        }
      }
    }
  }

  .store-main-list,
  .store-child-list {
    padding-left: 0;
  }
  .image {
    margin: 1rem 0;
  }
  .image-title {
    font-size: 1rem;
    margin: 2rem 0 1rem;
  }

  ${theme.mediaQueries.below.small} {
    .merchant-name {
      font-size: 1.25rem !important;
    }
    .validity-date {
      align-items: flex-start !important;
      flex-direction: column;
    }
    .promotion-page {
      .promotion-wrapper {
        display: flex;
        flex-direction: column-reverse;

        .banner-container {
          margin-left: -1rem;
          margin-right: -1rem;
        }

        .mobile-promopage-banner {
          position: relative;
          width: 100%;
          height: 52.6vw;
        }

        .header-container {
          width: 100%;
          float: none;
          padding: 0;

          header {
            height: auto !important;
            padding: 0 0 0px 0 !important;
          }
        }

        .page {
          padding: 0.7714285714rem 0 0;
          width: 100%;
          float: none;

          header {
            .first-block {
              margin-bottom: 2.3571428571rem;
            }
          }
        }
      }
    }
  }
`;

const PromotionDetail = ({ promotion, error }) => {
  const Router = useRouter();
  const { permalink } = Router.query;
  const {
    name,
    categories,
    categoryIds,
    webInfo,
    imgUrls,
    partner,
    stores,
    startDate,
    endDate,
    description,
    tnc,
  } = { ...promotion };
  const { formattedStartDate, formattedEndDate } = useFormatDate(startDate, endDate);
  const { landscapeBanner } = { ...imgUrls };
  const shareUrl = `${process.env.NEXT_PUBLIC_SITE_URL}/discover/promotion/${permalink}`;
  if (error) {
    return <Error404 />;
  }

  return (
    <StyledPromotion>
      <SeoHead
        title={partner.webInfo.metaTitle || name}
        description={partner.webInfo.metaDescription || name}
        image={landscapeBanner}
        noindex={categoryIds.length === 0}
      />
      <Contain>
        <div id="page-container" className="page-container" style={{ minHeight: '800px' }}>
          <section id="promotion-main-page">
            <div className="promotion-page">
              <div className="promotion-wrapper">
                <div className="header-container">
                  <div className="row">
                    <div className="columns">
                      <header>
                        <div className="banner-container hidden-mobile">
                          <Image
                            fill
                            priority="true"
                            alt="banner image"
                            src={landscapeBanner}
                            className="object-cover"
                            sizes="(max-width: 1200px) 50vw,33vw"
                          />
                        </div>
                        <div className="logo-container">
                          <div className="logo-inner-container">
                            <img src={partner.imgUrls.logo} alt={partner.name} />
                          </div>
                        </div>
                        <AboutDetails
                          slug={partner.slug}
                          name={partner.name}
                          description={partner.description}
                        />
                        <div className="line-divider" />
                        {stores?.length > 0 && <StoreDetails stores={stores} />}
                      </header>
                    </div>
                  </div>
                </div>
                <div className="page">
                  <header>
                    <div className="first-block">
                      <div className="block-type">
                        {categories.length > 0 && (
                          <h6 data-testid="merchant-category">{categories[0].name}</h6>
                        )}
                      </div>
                    </div>
                    <h2 className="merchant-name">
                      <Link href="/merchant/[permalink]" as={`/merchant/${partner.slug} `}>
                        {partner.name}
                      </Link>
                    </h2>
                    <h1 className="promotion-title">{name}</h1>
                    <div className="row validity-date">
                      <div className="info-table__label-icon">
                        <img
                          alt=""
                          className="icon-image calendar-icon"
                          src="/static/img/icons/calendar.svg"
                        />
                        <h4 className="info-table__label">Validity Period</h4>
                      </div>
                      <span className="info-table__text validity-value">
                        {formattedStartDate} - {formattedEndDate}
                      </span>
                    </div>
                    <Box mb="md">
                      <ShareButton shareUrl={shareUrl} title={name} />
                    </Box>
                  </header>
                  <div className="line-divider" />
                  {(webInfo.webDescription || description) && (
                    <div className="description">
                      <Expander
                        summary="Promotion Details"
                        active
                        details={
                          <div className="columns">
                            <div className="row">
                              <div className="columns">
                                <div className="subcontent wysiwyg-content">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: webInfo.webDescription
                                        ? webInfo.webDescription
                                        : lineBreaker(linkifyHtml(description)),
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      />
                    </div>
                  )}
                  <div className="line-divider d-block visible-mobile" />
                  {tnc && (
                    <div className="fine-prints">
                      <Expander
                        summary="Fine Print"
                        active
                        details={
                          <div
                            dangerouslySetInnerHTML={{
                              __html: lineBreaker(linkifyHtml(tnc)),
                            }}
                          />
                        }
                      />
                    </div>
                  )}
                  <div className="line-divider d-block visible-mobile" />
                </div>
                <div className="banner-container d-block visible-mobile">
                  <div className="mobile-promopage-banner">
                    <Image
                      fill
                      alt="banner image"
                      src={landscapeBanner}
                      sizes="(max-width: 768px) 100vw"
                      className="object-cover"
                    />
                  </div>
                </div>
                <div className="clear" />
              </div>
            </div>
          </section>
        </div>
      </Contain>
    </StyledPromotion>
  );
};

async function getData(ctx) {
  const promotion = await getPromoDetails(ctx.params.permalink);
  return {
    props: {
      promotion,
    },
  };
}

export const getServerSideProps = withErrorHandling(getData);

export default PromotionDetail;
